module.exports = __webpack_public_path__ + "static/media/close.fd43731d.svg";